import { MUI_MENU_ITEM, MUI_TAB, MUI_TOOLTIP } from "@constants/mui.constants";
import { createMuiTheme } from "@config/theme/mui-theme";
import { ThemeProvider } from "@mui/material/styles";
import type { ReactNode } from "react";

const theme = createMuiTheme("light");

const themeWithOverrides = {
	...theme,
	components: {
		...theme.components,
		MuiMenuItem: {
			styleOverrides: {
				root: {
					minHeight: 44,
					paddingTop: "10px",
					paddingBottom: "10px",
					boxSizing: "border-box",
					borderBottom: "0.5px solid #E7E7E7",
					"&:last-child": {
						borderBottom: "none",
					},
					color: MUI_MENU_ITEM.UNSELECTED.COLOR,
					"&.Mui-selected": {
						backgroundColor: `${MUI_MENU_ITEM.SELECTED.BACKGROUND_COLOR} !important`,
						color: `${MUI_MENU_ITEM.SELECTED.COLOR} !important`,
						borderRadius: 0,
						borderBottom: "none !important",
					},
					"&.Mui-selected:hover": {
						backgroundColor: `${MUI_MENU_ITEM.SELECTED.HOVER_COLOR} !important`,
						color: `${MUI_MENU_ITEM.SELECTED.COLOR} !important`,
					},
					'&[aria-selected="true"]': {
						backgroundColor: `${MUI_MENU_ITEM.SELECTED.BACKGROUND_COLOR} !important`,
						color: `${MUI_MENU_ITEM.SELECTED.COLOR} !important`,
						borderRadius: 0,
						borderBottom: "none !important",
					},
					'&[aria-selected="true"]:hover': {
						backgroundColor: `${MUI_MENU_ITEM.SELECTED.HOVER_COLOR} !important`,
						color: `${MUI_MENU_ITEM.SELECTED.COLOR} !important`,
					},
					"&:hover": {
						backgroundColor: `${MUI_MENU_ITEM.UNSELECTED.HOVER_COLOR} !important`,
						color: `${MUI_MENU_ITEM.UNSELECTED.HOVER_COLOR_TEXT} !important`,
					},
					"&.Mui-focusVisible": {
						backgroundColor: `${MUI_MENU_ITEM.UNSELECTED.HOVER_COLOR} !important`,
						color: `${MUI_MENU_ITEM.UNSELECTED.HOVER_COLOR_TEXT} !important`,
					},
				},
			},
		},
		MuiTooltip: {
			styleOverrides: {
				tooltip: {
					background: MUI_TOOLTIP.TOOLTIP_BACKGROUND_COLOR,
					color: MUI_TOOLTIP.TOOLTIP_COLOR,
					boxShadow: MUI_TOOLTIP.TOOLTIP_BOX_SHADOW,
					borderRadius: MUI_TOOLTIP.TOOLTIP_BORDER_RADIUS,
					fontSize: MUI_TOOLTIP.TOOLTIP_FONT_SIZE,
					padding: MUI_TOOLTIP.TOOLTIP_PADDING,
					letterSpacing: MUI_TOOLTIP.TOOLTIP_LETTER_SPACING,
					fontFamily: MUI_TOOLTIP.TOOLTIP_FONT_FAMILY,
				},
				arrow: {
					color: MUI_TOOLTIP.TOOLTIP_BACKGROUND_COLOR,
				},
			},
		},
		MuiTabs: {
			styleOverrides: {
				root: {
					"& .MuiTabs-indicator": {
						backgroundColor: MUI_TAB.SELECTED.INDICATOR_COLOR,
						height: 4,
						borderRadius: 2,
					},
				},
			},
		},
		MuiTab: {
			styleOverrides: {
				root: {
					textTransform: "capitalize",
					fontSize: 12,
					borderRadius: 8,
					minHeight: 40,
					marginRight: 8,
					transition: "background 0.2s, color 0.2s",
					"&.Mui-selected": {
						color: MUI_TAB.SELECTED.TAB_NAME_COLOR,
						backgroundColor: MUI_TAB.SELECTED.BACKGROUND_COLOR,
					},
					"&.Mui-selected:hover": {
						backgroundColor: MUI_TAB.SELECTED.HOVER_COLOR,
					},
					"&:hover": {
						backgroundColor: MUI_TAB.SELECTED.HOVER_COLOR,
					},
				},
			},
		},
	},
};

export function MUIThemeProvider({ children }: { children: ReactNode }) {
	return <ThemeProvider theme={themeWithOverrides}>{children}</ThemeProvider>;
}
